import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {PartnerAdvertisingPlatform} from '../../../../../models/partner/partner-advertising-platform';
import {PartnerMetaAdsService} from '../../../../../services/partner/partner-meta-ads.service';

@Component({
  imports: [],
  selector: 'app-meta-ads-config-form',
  styleUrl: './meta-ads-config-form.component.scss',
  templateUrl: './meta-ads-config-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MetaAdsConfigFormComponent implements OnChanges {
  @Input() partnerAdvertisingPlatform: PartnerAdvertisingPlatform | null = null;

  accountInfos: any | null = null;
  partnerId: number | null = null;

  constructor(
    private partnerMetaAdsService: PartnerMetaAdsService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['partnerAdvertisingPlatform']) {
      this.partnerId = this.partnerAdvertisingPlatform?.partnerId ?? null;
      this.refreshAccountInfos();
    }
  }

  refreshAccountInfos(): void {
    if (this.partnerId) {
      this.accountInfos = null;
      this.partnerMetaAdsService.getAccountInfos(this.partnerId).subscribe((accountInfos) => {
        this.accountInfos = accountInfos;
      });
    }
  }

  getMetaAdsTimezoneOffset(): string {
    if (this.accountInfos) {
      let offset = this.accountInfos.timezoneOffset;
      if (offset > 0) {
        return 'UTC+' + offset;
      }

      if (offset < 0) {
        return 'UTC' + offset;
      }

      return 'UTC';
    }

    return '';
  }
}
